import { JsonPipe } from '@angular/common';
import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { entityState, jkGlb, jkRestReturn, MaterialModule, ModalHeaderComponent, } from 'jk-service';
import { PageKind, UiModeType, } from 'jk-service';
import { MtrwdService,  } from '../_service_mtr';
import { MtrwdEditComponent, } from '../_edit_mtr';
import { JackBaseComponentModule } from 'jk-service';
import { jkSingleComponent, JkaggridComponent, AdvComModule } from 'jk-advcom';


@Component({
  selector: 'app-mtrki01',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
    JkaggridComponent,
    JsonPipe,
  ],
  templateUrl: './mtrki01.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Mtrki01Component extends jkSingleComponent implements OnInit {
  override _programId = 'mtrki01';
  importMtrwlObj: unknown;
  importMtrwlError = '';
  hasImportedMtrwl = false;
  override   get srv(): MtrwdService | any {
    return this.masterSrv;
  }
  override set srv(srv: MtrwdService | any) {
    this.masterSrv = srv;
  }

  constructor() {
    super();
    this.srv = new MtrwdService();
    this.srv.programId = this.programId; // ###

    this.uiMode = UiModeType.dialog;
    this.title = '工作管理建立';
    this.gridInitOpt = { programId: this.programId, sortField: 'WD002', sort: 'desc', defaultSort: null, pageKind: this.pageKind };
    this.qbeConfig.addField = 'WD002,WD004,WD021,WD029,WD014';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = MtrwdEditComponent;

    //this.constructorInit();
  }

  override onWindowResize($event?: any) {
    super.onWindowResize($event);
  }
  override async constructorInit() {
    await super.constructorInit();
    //this.srv.cdr = this.cdr;
  };

  importMtrwl(): void {
    const url = `${this.srv.login.host}/mtr/import-mtrwl?prefixLike=note&wd015=04`;
    this.importMtrwlError = '';
    this.hasImportedMtrwl = false;

    this.srv.orm.http.get(url).subscribe({
      next: (response: jkRestReturn): void => {
        this.importMtrwlObj = response.obj;
        this.hasImportedMtrwl = true;
        this.cdr?.detectChanges();
      },
      error: (error: unknown): void => {
        this.importMtrwlError = error instanceof Error ? error.message : '匯入速記失敗';
        this.cdr?.detectChanges();
      },
    });
  }
  //--------------------------------------------------
  WD002Change(newValue: string): void {
    this.item.WD002 = newValue;
    this.srv.item = this.item;
    this.srv.WD002Change(newValue);
  }
  WD014Change(newValue: string): void {
    setTimeout(async () => {
      this.srv.item = this.item;
      await this.srv.WD014Change(newValue, this);
      this.cloneField(this.srv.item, this.item);
      this.cdr.detectChanges();
    });
  }


  WD021Change(newValue: string): void {
    setTimeout(async () => {
      this.srv.item = this.item;
      await this.srv.WD021Change(newValue, this);
      this.cloneField(this.srv.item, this.item);
      this.cdr.detectChanges();
    });
  }
  content(): string {
    return this.item.WD003 || '';
  }
  editContent(value: string): void {
    this.item.WD003 = value;
    //this.markEdited();
  }
  //-------------------------------
  modal_header!: ModalHeaderComponent; // ###
  modalHeaderReady($event: any) {
    this.modal_header = $event;
  }

  isDialog: boolean = false;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  ownForm: any = this;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  get isReadOnly(): boolean {
    if (this.srv) {
      return this.isBrowse;
    }
    return false;
  }
  //item:TTable = {} as TTable; // 這樣才不會undefined.
  /* 虛欄位抓這裡.this.item 不是any,是table實欄位 */
  get itemAny(): any {
    return this.item;
  }
  _state: entityState = entityState.dsBrowse;
  async doOk(e: any): Promise<boolean> {
    //let bool = await super.doOk(e);
    const ownFormCdr = this.ownForm?.cdr;
    ownFormCdr?.detach();
    try {
      return await new Promise<boolean>((resolve) => {
        window.setTimeout(async () => {
          this.cloneField(this.item, this.srv.item);
          let bool = await (this.srv as any).doUIOk();
          if (bool) {
            //this.dialogRef.close(true);

          }
          resolve(bool);
        });
      });
    } finally {
      window.setTimeout(() => {
        ownFormCdr?.reattach();
        ownFormCdr?.detectChanges();
      });
    }
  }
  doCancel(e: any): boolean {
    //let bool = super.doCancel(e);
    let bool = (this.srv as any).doUICancel();
    if (bool) {
      //this.dialogRef.close(false);
    }
    return bool;
  }

}
